import React, { useEffect, useState } from "react";
import moment from "moment";
import GlobalNav from "../components/GlobalNav";
import PillarsGrid from "../components/PillarsGrid";
import Footer from "../components/Footer";
import "../styles/buttons.css";
import "./AboutPage.css";

function extractArtistList(json) {
  if (Array.isArray(json)) return json;
  if (Array.isArray(json?.artists)) return json.artists;
  return [];
}

export default function AboutPage() {
  const [featuredMembers, setFeaturedMembers] = useState(null);
  const [totalCount, setTotalCount] = useState(null);

  useEffect(() => {
    fetch("/api/registry/featured")
      .then((r) => r.json())
      .then((json) => setFeaturedMembers(extractArtistList(json)))
      .catch((err) => console.error("Error fetching featured members:", err));

    fetch("/api/registry")
      .then((r) => r.json())
      .then((json) => setTotalCount(json.count ?? extractArtistList(json).length))
      .catch((err) => console.error("Error fetching registry count:", err));
  }, []);

  const members = featuredMembers ?? [];

  return (
    <div className="about-page">
      <GlobalNav activeHref="/about" ctaLabel="Join the collective" />

      <div className="about-hero">
        <div className="about-hero-inner">
          <div className="about-hero-eyebrow">Who we are</div>
          <h1 className="about-hero-title">Music is healing</h1>
          <p className="about-hero-sub">
            Founded on the belief that music is not entertainment but medicine —
            a practice of collective healing across mind, body, community, and spirit.
          </p>
        </div>
      </div>

      <div className="about-body">

        {/* Origin */}
        <div className="about-section-label">Origin</div>
        <div className="about-origin">
          <p className="about-origin-text">
            Music Is Healing is a community learning organization and creative
            media services agency started by Pierre-Valery Tchetgen
            (Artist-Educator and Entrepreneur), also known by the stage name{" "}
            <a href="http://akwerius.com" target="_blank" rel="noopener noreferrer">Akwerius</a>.
            The seeds were planted during Summer 2006 in Chicago as the
            Voices CAMP program, and grew into the Word.Sound.Life. network,
            established as a student organization on the UC Berkeley campus
            from 2007 to 2019.
          </p>
          <p className="about-origin-text">
            The Music Is Healing Us Tour was initially launched in 2014 at
            the Democracy Center in Boston, after several artist members
            (singers, producers and musicians) decided to form an
            independent collective to produce and license original music,
            art and film works. The project has since relocated to Mount
            Shasta, CA, where it formally became registered as a small
            business in 2018, after successfully hosting the{" "}
            <a href="/events">Unity through Music</a> grassroots festival
            for two consecutive years.
          </p>
        </div>

        {/* Four pillars */}
        <div className="about-section-label">The four pillars</div>
        <div className="about-pillars">
          <PillarsGrid variant="detailed" />
        </div>

        {/* Collective members */}
        <div className="about-section-label">
          Collective members
          {totalCount != null && (
            <span className="about-members-count"> — {totalCount} artists</span>
          )}
        </div>
        <div className="about-members">
          {members.map((m) => {
            const name = m.artistname ||
              [m.firstname, m.lastname].filter(Boolean).join(" ");
            const slug = m.slug || m.username;
            return (
              <a
                key={m.id}
                className="about-member-card"
                href={`/epk/${slug}`}
                title={name}
              >
                <div className="about-member-photo">
                  {m.photo
                    ? <img src={m.photo} alt={name} />
                    : <span>{name?.charAt(0)}</span>
                  }
                </div>
                <div className="about-member-name">{name}</div>
                <div className="about-member-role">{m.roles || m.role}</div>
              </a>
            );
          })}
          {members.length === 0 && featuredMembers !== null && (
            <p className="about-members-empty">No featured members yet — feature some from the DB.</p>
          )}
        </div>
        <div className="about-members-note">
          Full directory is members-only —{" "}
          <a href="/registry">view the artist registry</a>
        </div>

        {/* CTAs */}
        <div className="about-ctas">
          <a className="mihu-btn-primary-lg" href="/register">Apply to join</a>
          <a className="mihu-btn-secondary-lg" href="/donate">Support MIHU</a>
        </div>
      </div>

      <Footer />
    </div>
  );
}
